// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import PasskeyEnrolmentController from "./passkey_enrolment_controller"
application.register("passkey-enrolment", PasskeyEnrolmentController)

import PasskeySignInController from "./passkey_sign_in_controller"
application.register("passkey-sign-in", PasskeySignInController)

import ResendCountdownController from "./resend_countdown_controller"
application.register("resend-countdown", ResendCountdownController)

import SidebarResetController from "./sidebar_reset_controller"
application.register("sidebar-reset", SidebarResetController)

